module.exports = __webpack_public_path__ + "static/media/react.d71af0b2.png";